import React from "react";
import { CornerRightDown } from "lucide-react";

/**
 * The opening line a text from an agent's own mobile starts with, shown on top
 * of the message box the way MessageBlocksTail shows what goes underneath.
 *
 * Simon Abbott (Monday 13392775822, 30 Oct 2026): "When an agent is sending a
 * text message out from their own number, it is now law that the text starts
 * with "Hi, it's (agents name) from Collings Real Estate" ... Please make all
 * bulk texts being sent by agents from their own number autopopulate this."
 *
 * Kept out of the editable box on purpose: it is a legal line, so nobody can
 * delete it by accident, and switching agent swaps it without touching what
 * was typed. The backend adds it at send time (core.services.sms_text).
 */
export default function SmsIntroHead({ intro, sender, className = "" }) {
  if (!intro) return null;
  return (
    <div
      data-testid="sms-intro-head"
      className={`rounded-t-lg border border-b-0 border-dashed border-gray-300 bg-gray-50 px-3 py-2 ${className}`}
    >
      <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        <CornerRightDown className="w-3 h-3" />
        Starts with this line, because it sends from {sender ? `the agent's mobile (${sender})` : "the agent's own mobile"}
      </p>
      <p className="text-xs text-gray-600">{intro}</p>
    </div>
  );
}
